/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Selectors for the app module
 */

import { setSelectIsBot } from '@zcode/lazy-loadable-section'
import type { State } from '@zcode/state-type'
import { compose } from 'redux'
import { selectLocation } from '../../../selectors/selectorsCurrentSearch'
import { selectEntity } from '../../../selectors/selectorsDetail'

export const selectApp = (state: State) => state?.app

export const selectIsMounted = compose((app) => app?.mounted, selectApp)

export const selectIsOnline = compose((state) => state.online, selectApp)

export const selectNow = compose((state) => state.now, selectApp)

export const selectWarnOffline = compose((state) => state.warnOffline, selectApp)

export const checkLoggedIn = (
  state: State
): state is State & {
  bundle: State['bundle'] & {
    user: NonNullable<State['bundle']['user']>
  }
} => {
  return !!state.bundle?.user?.userId
}

export function getUser(
  state: State & {
    bundle: State['bundle'] & { user: NonNullable<State['bundle']['user']> }
  }
): NonNullable<State['bundle']['user']>
export function getUser(state: State): NonNullable<State['bundle']['user']> | State['localUser']
export function getUser(state: State) {
  return checkLoggedIn(state) ? state.bundle.user : state.localUser
}

export function selectIsSudoer(state: State) {
  return checkLoggedIn(state) ? !!state.bundle.sudoer : false
}

export const selectIsBot = (state: { readonly app: { readonly bot: boolean } }) => state?.app?.bot
setSelectIsBot(selectIsBot)

export const selectHasInitialLocationChanged = compose(
  (state) => state?.initialLocationChanged,
  selectApp
)

export const selectInitialLocationHasUtmParams = compose(
  (state) => state?.initialLocationHasUtmParams,
  selectApp
)

export const selectIsMobile = compose((state) => state.mobile, selectApp)

export const selectIsAppDownloadBarShowing = compose(
  (state) => state.appDownloadBarShowing,
  selectApp
)

export const selectLocalStorageSynced = compose((state) => state.localStorageSynced, selectApp)

export const selectIsSendingMessage = compose((state) => state.sendingMessage, selectApp)

export const selectIsSendingTour = compose((state) => state.sendingTour, selectApp)

// copied from packages/nzr/src/utils/loadGlobalNavLinkpackNZR.ts
export const selectUrlInAnyRoute: (state: State) => string | undefined = (state: State) => {
  return (
    selectLocation(state)?.url ??
    selectEntity(state)?.cityStateHood ??
    selectEntity(state)?.cityState ??
    undefined
  )
}
